import type * as React from "react";
import { cn } from "../lib/cn.js";

/** Keyboard shortcut hint, e.g. <Kbd>N</Kbd>. */
export function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-kbd
      className={cn(
        "inline-flex h-[18px] min-w-[18px] items-center justify-center border border-current/30 px-1 font-mono text-[10px] font-medium opacity-80",
        className,
      )}
      {...props}
    />
  );
}
